import { InjectionToken } from "@angular/core";
import { RouterUtilityOptions } from "./router-utilities.service";

export const UTILITY_OPTIONS = new InjectionToken<RouterUtilityOptions>("UTILITY_OPTIONS");
